<template>
    <div>
        <div class="grid grid-cols-3 gap-8 mobile:mt-12 tablet:mt-16 tablet:gap-2 mobile:grid-cols-1 mobile:gap-6">
            <!--BASIC-->
            <div class="border border-grey-300 rounded-2xl [&>div]:p-6 divide-y divide-grey-300 flex flex-col" :class="{'col-start-3  row-start-1': isReversed}">
                <div class="space-y-5">
                    <div class="box-content">
                        <img src="/images-new/pricing/basic.svg" alt="basic" />
                    </div>
                    <div>
                        <span class="block font-semibold text-xl tablet:text-lg">Basic</span>
                    </div>
                    <div>
                        <span class="text-3xl tablet:text-2xl font-bold mr-2">€ {{packages[0].abonnement.price}}</span><span class="text-grey-800 text-sm">{{translate('per_jaar')}}</span>
                    </div>
                    <div>
                        <a :disabled="basicDisabled" :href="getPurchaseLink(PackageType.BASIC)" class="btn btn-ghost w-full">
                            {{translate('doorgaan_met')}} Basic
                        </a>
                    </div>
                </div>
                <div class="space-y-4 grow tablet:text-sm">
                    <div>
                        <span class="font-semibold text-md tablet:text-base">{{translate('geeft_toegang_tot')}}</span>
                    </div>
                    <ul class="leading-normal space-y-3 text-grey-800">
                        <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('basic_usp_1')}}</li>
                        <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('basic_usp_2')}}</li>
                        <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('basic_usp_3')}}</li>
                        <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('basic_usp_4')}}</li>
                    </ul>
                </div>
                <div class="space-y-4 tablet:text-sm">
                    <div>
                        <span class="font-semibold text-md tablet:text-base">{{translate('gebruik')}}</span>
                    </div>
                    <ul class="leading-normal space-y-3 text-grey-800">
                        <li>{{translate('250_opzoekingen')}}</li>
                        <li>{{translate('50_alerts')}}</li>
                    </ul>
                </div>
                <div class="flex justify-between items-center tablet:flex-wrap gap-3">
                    <span class="font-semibold text-md tablet:text-base">{{translate('basisrapporten')}}</span>
                    <a :href="'/'+language+'/sample/report/basic'" target="_blank" class="btn btn-ghost btn-sm">{{translate('bekijken')}}</a>
                </div>
            </div>
    
            <!--STANDARD-->
            <div class="border border-grey-300 rounded-2xl [&>div]:p-6 divide-y divide-grey-300 flex flex-col":class="{'col-start-2 row-start-1': isReversed}">
                <div class="space-y-5">
                    <div class="box-content">
                        <img src="/images-new/pricing/standard.svg" alt="standard" />
                    </div>
                    <div>
                        <span class="block font-semibold text-xl tablet:text-lg">Standard</span>
                    </div>
                    <div>
                        <span class="text-3xl tablet:text-2xl font-bold mr-2">€ {{packages[1].abonnement.price}}</span><span class="text-grey-800 text-sm">{{translate('per_jaar')}}</span>
                    </div>
                    <div>
                        <a :disabled="standardDisabled" :href="getPurchaseLink(PackageType.STANDARD)" class="btn btn-ghost w-full">
                            {{translate('doorgaan_met')}} Standard
                        </a>
                    </div>
                </div>
                <div class="space-y-4 grow tablet:text-sm">
                    <div>
                        <span class="font-semibold text-md tablet:text-base">{{translate('alles_van_basic_en')}}</span>
                    </div>
                    <ul class="leading-normal space-y-3 text-grey-800">
                        <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('standard_usp_1')}}</li>
                        <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('standard_usp_2')}}</li>
                        <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('standard_usp_3')}}</li>
                    </ul>
                </div>
                <div class="space-y-4 tablet:text-sm">
                    <div>
                        <span class="font-semibold text-md tablet:text-base">{{translate('gebruik')}}</span>
                    </div>
                    <ul class="leading-normal space-y-3 text-grey-800">
                        <li>{{translate('250_opzoekingen')}}</li>
                        <li>{{translate('50_alerts')}}</li>
                    </ul>
                </div>
                <div class="flex justify-between items-center tablet:flex-wrap gap-3">
                    <span class="font-semibold text-md tablet:text-base">{{translate('standardrapporten')}}</span>
                    <a :href="'/'+language+'/sample/report/standard'" target="_blank" class="btn btn-ghost btn-sm">{{translate('bekijken')}}</a>
                </div>
            </div>
    
    
            <!--PREMIUM-->
            <div class="relative flex flex-col border border-primary-300 rounded-2xl shadow-sm [box-shadow:0px_0px_0px_4px_rgba(3,_104,_255,_0.05)]" :class="{'col-start-1 row-start-1': isReversed}">
                 <span class="absolute right-2 top-2">
                    <span class="rounded-lg bg-primary-100 border border-primary-200 text-primary-500 font-medium py-1 px-2 text-sm">
                        {{translate('meest_gekozen')}}
                    </span>
                </span>
                <div class="[&>div]:p-6 divide-y divide-grey-300 flex flex-col h-full">
                    <div class="space-y-5">
                        <div class="box-content">
                            <img src="/images-new/pricing/premium.svg" alt="premium" />
                        </div>
                        <div>
                            <span class="block font-semibold text-xl tablet:text-lg">Premium</span>
                        </div>
                        <div>
                            <span class="text-3xl tablet:text-2xl font-bold mr-2">€ {{ premiumPrice }}</span><span class="text-grey-800 text-sm">{{translate('per_jaar')}}</span>
                        </div>
                        <div>
                            <a :disabled="premiumDisabled" :href="getPurchaseLink(PackageType.PREMIUM)" class="btn btn-primary w-full">
                                {{translate('doorgaan_met')}} Premium
                            </a>
                        </div>
                    </div>
                    <div class="space-y-4 grow tablet:text-sm">
                        <div>
                            <span class="font-semibold text-md tablet:text-base">{{translate('alles_van_standard_en')}}</span>
                        </div>
                        <ul class="leading-normal space-y-3 text-grey-800">
                            <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('premium_usp_1')}}</li>
                            <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('premium_usp_2')}}</li>
                            <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('premium_usp_3')}}</li>
                            <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('premium_usp_4')}}</li>
                            <li class="inline-flex gap-3 items-start"><i class="fas text-sm mt-0.5 fa-check text-primary-400"></i>{{translate('premium_usp_5')}}</li>
                        </ul>
                    </div>
                    <div class="space-y-4 tablet:text-sm">
                        <div>
                            <span class="font-semibold text-md tablet:text-base">{{translate('gebruik')}}</span>
                        </div>
                        <ul class="leading-normal space-y-3 text-grey-800">
                            <li>{{translate('250_opzoekingen')}}</li>
                            <li>{{translate('250_alerts')}}</li>
                        </ul>
                    </div>
                    <div class="flex justify-between items-center tablet:flex-wrap gap-3">
                        <span class="font-semibold text-md tablet:text-base">{{translate('premiumrapporten')}}</span>
                        <a :href="'/'+language+'/sample/report/premium'" target="_blank" class="btn btn-ghost btn-sm">{{translate('bekijken')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {useStore} from "../../../../main-store";
import {defineComponent} from 'vue';
import {Language} from "../../../../types/dto/Language";
import {Package, PackageType} from "../../types";

const store = useStore();

export default defineComponent({
    name: "pricing-grid",
    props: {
        language: String as () => Language,
        isReversed: Boolean,
        isLoggedin: Boolean,
        currentAbo: String as () => PackageType | null
    },
    data() {
        const packages = window.cw.packages as Package[];
        return {
            store,
            PackageType,
            packages
        }
    },
    computed: {
        premiumPrice(): number {
            return this.packages.find(p => p.abonnement.abonnement === PackageType.PREMIUM)?.abonnement.price ?? 0;
        },
        basicDisabled(): boolean {
            return this.currentAbo == "premium" || this.currentAbo == "liza-premium" || this.currentAbo == "standard" || this.currentAbo == "basic";
        },
        standardDisabled(): boolean {
            return this.currentAbo == "premium" || this.currentAbo == "liza-premium" || this.currentAbo == "standard";
        },
        premiumDisabled(): boolean {
            return this.currentAbo == "premium" || this.currentAbo == "liza-premium";
        }
    },
    methods: {
        getPurchaseLink(pack: PackageType): string {
            if(pack == PackageType.PREMIUM || pack == PackageType.LIZAPREMIUM) {
                if(this.currentAbo == "basic" || this.currentAbo == "standard") {
                    return `/upgrade-subscription/${pack}`;
                }
            }
            if(pack == PackageType.STANDARD) {
                if(this.currentAbo == "basic" ) {
                    return `/upgrade-subscription/${pack}`;
                }
            }
            
            return `/${this.language}/order/${pack}`;
        }
    }
});
</script>